module.exports = __webpack_public_path__ + "img/touxiang.7250683f.svg";